export enum VehicleAbroadImported {
    ABROAD_IMPORTED_NO = 'ABROAD_IMPORTED_NO',
    ABROAD_IMPORTED_OVER_12_MONTHS = 'ABROAD_IMPORTED_OVER_12_MONTHS',
    ABROAD_IMPORTED_UNDER_12_MONTHS = 'ABROAD_IMPORTED_UNDER_12_MONTHS',
}
